/**
 * The words both share dialogs use for reach beyond the workspace.
 *
 * A file and a conversation are shared out by two different dialogs, and the second tab of each asks the
 * same question: who outside this workspace gets a copy. The wording lives here so the two read as one
 * product rather than as two inventions, and so the employee guide can quote one set of labels.
 *
 * Fixed text plus a count, never a rephrasing: the tab a person is told to click has to be the tab that
 * is there.
 */
export const OUTSIDE_TAB_LABEL = 'Outside this workspace';

/** The tab's label, carrying the number of live shares once there are any to carry. */
export function outsideTabLabel(liveCount: number): string {
  return liveCount > 0
    ? `${OUTSIDE_TAB_LABEL} · ${liveCount}`
    : OUTSIDE_TAB_LABEL;
}

/**
 * The collapsed shares row: what is behind the disclosure, counted.
 *
 * The count is of shares that STILL OPEN, because that is the set the expanded list draws — counting
 * revoked ones would make the row and the list disagree, and the row is the half a person reads.
 */
export function sharedLinksLabel(liveCount: number): string {
  return liveCount === 1
    ? '1 link you have shared'
    : `${liveCount} links you have shared`;
}
